import { safeFetchAPI } from '@/api/index.ts';
import { logger, utils } from '@/helpers';
import { Campaign } from '@/types';
import { create } from 'zustand';
import { LOCAL_CAMPAIGN_REPORT_TEST_TOKEN, LOCAL_CAMPAIGN_REPORT_TEST_UID } from '../campaign-reports/createCampaignReportFiltersStore';

export type CampaignReportCampaignStoreState = {
	campaign: Campaign | null;
	loading: boolean;
	loaded: boolean;
};

export type CampaignReportCampaignStoreActions = {
	fetchCampaign: (campaignID: string) => Promise<void>;
	reset: () => void;
};

export type CampaignReportCampaignStore = CampaignReportCampaignStoreState & CampaignReportCampaignStoreActions;

const initialState: CampaignReportCampaignStoreState = {
	campaign: null,
	loading: false,
	loaded: false,
};

export const useCampaignReportCampaignStore = create<CampaignReportCampaignStore>((set, get) => ({
	...initialState,
	fetchCampaign: async (campaignID: string) => {
		set({ loading: true });
		const [response, error] = await safeFetchAPI<Campaign>(`/campaign/:uid/${campaignID}`, {
			forceToken: LOCAL_CAMPAIGN_REPORT_TEST_TOKEN,
			uid: LOCAL_CAMPAIGN_REPORT_TEST_UID,
		});
		if (error) {
			utils?.toaster?.addToast?.({
				message: error ?? 'Error fetching campaign',
				type: 'danger',
			});
			set({ loading: false, loaded: true });
			return;
		}
		logger.log('/campaign/:uid/:campaignID').prefix(campaignID).add({ campaignID }).addnl('response', response);
		set({ campaign: response, loading: false, loaded: true });
	},
	reset: () => set(initialState),
}));
